import React, { useState } from "react";
import { Select, MenuItem, OutlinedInput, InputAdornment, Chip, Box } from "@mui/material";
import { ReactComponent as Arrow_Up } from "assets/filter/arrow-up.svg";
import { ReactComponent as Arrow_Down } from "assets/filter/arrow-down.svg";
import { ReactComponent as Vector } from "assets/icons/ic_round-close.svg";

const ChipSelect = ({ value, onChange, onDelete, width, options = [], placeholder = "", customStyles = {}, menuStyles = {}, chipSx = {}, multiple = true, modal = "", setParentOpen, ...rest }) => {
  const [open, setOpen] = useState(false);
  const formatSelected = (text) => {
    if (!text) return "";
    return text.length > 32 ? `${text.slice(0, 32)}...` : text;
  };

  return (
    <Select
      multiple={multiple}
      value={value}
      onChange={onChange}
      fullWidth
      displayEmpty
      open={open}
      onOpen={() => {
        setOpen(true);
        if (setParentOpen) setParentOpen(true);
      }}
      onClose={() => {
        setOpen(false);
        if (setParentOpen) setParentOpen(false);
      }}
      renderValue={(selected) => {
        if (!selected || (Array.isArray(selected) && selected.length === 0)) {
          return <span style={{ color: "#8B8B8B", fontFamily: "Poppins" }}>{placeholder}</span>;
        }

        if (multiple) {
          return (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                ...(modal === "live stream" && {
                  overflowY: "auto",
                  maxHeight: "90px",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }),
              }}
            >
              {selected.map((val) => (
                <Chip
                  key={val}
                  label={formatSelected(val)}
                  deleteIcon={<Vector />}
                  onDelete={() => onDelete(val)}
                  onMouseDown={(e) => e.stopPropagation()}
                  sx={{
                    fontFamily: "Karla",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "21px",
                    color: "#191818",
                    backgroundColor: "#D9D9D9",
                    borderRadius: "5px",
                    ...chipSx,
                  }}
                />
              ))}
            </Box>
          );
        }

        return <div>{selected}</div>;
      }}
      label={placeholder}
      input={
        <OutlinedInput
          fullWidth
          endAdornment={
            <InputAdornment position="start">
              <div style={{ position: "absolute", top: 12, right: 12 }}>
                {open ? (
                  <Arrow_Up />
                ) : (
                  <Arrow_Down
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpen(true);
                    }}
                    cursor={"pointer"}
                  />
                )}
              </div>
            </InputAdornment>
          }
        />
      }
      MenuProps={{
        PaperProps: {
          sx: {
            marginTop: "3px",
            backgroundColor: "#FFFFFF",
            color: "#000000",
            borderRadius: "5px",
            padding: "5px !important",
            ...menuStyles,
            ...(modal === "live stream" && {
              maxHeight: "145px",
              overflowY: "auto",
            }),
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "transparent",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
            "& .MuiList-root": {
              "& .MuiMenuItem-root": {
                padding: "10px 5px !important",
                margin: "0px 0px",
                display: "flex",
                justifyContent: "flex-start",
                alignContent: "center",
                "&:hover": {
                  backgroundColor: "#444444",
                  color: "#FFFFFF",
                  borderRadius: "5px",
                  margin: "0px 0px",
                },
              },
            },
          },
        },
      }}
      sx={{
        fontFamily: "Karla",
        fontSize: "18px",
        lineHeight: "22px",
        fontWeight: 500,
        height: "auto",
        borderRadius: "5px",
        textTransform: "none",
        color: open ? "#000000" : "#000000",
        backgroundColor: open ? "#FFFFFF" : "#FFFFFF",
        "&:hover": {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
        border: "1px solid #000000",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        textAlign: "flex-start",
        padding: "0px 5px !important",
        width,
        "& .MuiSelect-select": {
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          gap: "6px",
          padding: "10px 5px !important",
        },
        "& .MuiSelect-icon": {
          display: "none",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&:focus": {
          backgroundColor: "transparent",
        },
        ...customStyles,
      }}
      {...rest}
    >
      {options?.map((value) => (
        <MenuItem
          key={value}
          value={value}
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#D9D9D9",
              borderRadius: "5px",
            },
          }}
        >
          {value}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ChipSelect;
